export const config = {
  baseURL: 'https://api.miaso-indyka.com.ua',
  token: '123',
  password: 'admin',
  authToken: 'xlQuI939ZIu-EvDoE-xCD_8C-Pwck8LMLEu9JQ'
};
